import CheckIcon from "@mui/icons-material/Check";
import React from "react";
import { useTranslation } from "react-i18next";
import "./NewTrainingCard.css";

interface NewTrainingCardProps {
  onSelect: () => void;
  image: string;
  type: string;
  variant: string;
  selected: boolean;
  disabled?: boolean;
}

/** One of the two type cards on the wizard's first step. The whole card is the control. */
export default function NewTrainingCard(props: NewTrainingCardProps) {
  const { t } = useTranslation();
  const { image, type, variant, selected, onSelect, disabled } = { ...props };
  const testId = `new-training-card-${type.toLowerCase()}`;

  const select = () => {
    if (!disabled) onSelect();
  };

  return (
    <div
      className={
        "newtrainingcard-root" +
        (selected ? " newtrainingcard-root-selected" : "") +
        (disabled ? " newtrainingcard-root-disabled" : "")
      }
      role="radio"
      aria-checked={selected}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={select}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          select();
        }
      }}
      data-testid={testId}
    >
      <div className={"newtrainingcard-tag newtrainingcard-tag-" + variant}>
        {type}
      </div>
      <div className="newtrainingcard-image">
        <img src={image} alt="" />
        {disabled && (
          <div className="newtrainingcard-coming-soon">
            <span className="newtrainingcard-coming-soon-text">
              Coming Soon
            </span>
            <div className="newtrainingcard-coming-soon-overlay" />
          </div>
        )}
      </div>

      <div className="newtrainingcard-footer">
        <div className="newtrainingcard-title">
          <span className={"newtrainingcard-title-" + variant}>{type}</span>
          <span>{t("training")}</span>
        </div>
        {selected && (
          <span
            className="newtrainingcard-check"
            data-testid={`${testId}-check`}
          >
            <CheckIcon sx={{ fontSize: 18 }} />
          </span>
        )}
      </div>
    </div>
  );
}
